<template>
  <div>
    <a id="skippy" class="sr-only sr-only-focusable" href="#main">Skip to content</a>
    <header id="header">
      <div class="container">
        <div id="logo">
          <router-link :to="{name: 'Search' }">
            <img src="/img/login-logo.png" alt />
          </router-link>
        </div>

        <nav id="guestNav" aria-label="User">
          <ul class="list-reset">
            <li>
              <a :href="`${signUpUrl}signup`" target="_blank">Sign Up</a>
            </li>
            <li>
              <a :href="`${signUpUrl}login`" target="_blank">Sign In</a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { UrlKeys } from "@/utils/enums";

export default {
  name: "Header",
  data() {
    return {
    };
  },
  async created() {
    if (!this.signUpUrl)
      await this.fetchSiteUrl(UrlKeys.L2BSignInUp);
  },
  computed: {
    ...mapState(["signUpUrl"])
  },
  methods: {
    ...mapActions(["fetchSiteUrl"])
  }
};
</script>